var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 788,
    viewBox: "0 0 547 788",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 273.5,
    y: 376.383,
    width: 273.5,
    height: 109.4,
    fill: "#3AF2AE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 540.995,
    width: 273.5,
    height: 109.4,
    fill: "#3AF2AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 136.75,
    y: 514.5,
    width: 273.5,
    height: 109.4,
    transform: "rotate(-90 136.75 514.5)",
    fill: "#3AF2AE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 300.85,
    y: 788,
    width: 273.5,
    height: 109.4,
    transform: "rotate(-90 300.85 788)",
    fill: "#3AF2AE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 410.036,
    y: 71.6802,
    width: 100,
    height: 40,
    transform: "rotate(-45 410.036 71.6802)",
    fill: "#5CFFE9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 303.969,
    y: 177.746,
    width: 100,
    height: 40,
    transform: "rotate(-45 303.969 177.746)",
    fill: "#5CFFE9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 374.68,
    y: 99.9644,
    width: 100,
    height: 40,
    transform: "rotate(-135 374.68 99.9644)",
    fill: "#5CFFE9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 480.746,
    y: 206.031,
    width: 100,
    height: 40,
    transform: "rotate(-135 480.746 206.031)",
    fill: "#5CFFE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape);
export default __webpack_public_path__ + "static/media/bg-shape.98044caecd0c873077bbd24081967ca0.svg";
export { ForwardRef as ReactComponent };